import React from 'react';
import { Box } from '@curves/ui-base';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PageHeader from '@Local/Components/Layout/PageHeader';
import TabsWithActions from '@Local/Components/Layout/TabsWithActions';
/**
 * PageLayout 是一個通用的頁面版型容器，提供統一的間距與寬度設定。
 * 常用於內頁的主要區塊包裹內容。
 *
 * - 可以搭配 `PageLayout.Header` 或 `PageLayout.Tabs` 使用，但兩者請擇一。
 * - 預設使用 `Box` 元件作為容器，並套用統一的 CSS class。
 *
 * @component
 * @example
 * return (
 *   <PageLayout>
 *     <PageLayout.Header title="標題" />
 *     <main>內容區塊</main>
 *   </PageLayout>
 * );
 *
 * @param {Object} props
 * @param {string} [props.className] - 追加的 className。
 * @param {React.ReactNode} props.children - 內部內容。
 *
 * @returns {JSX.Element}
 */
const PageLayout = ({ className, children, ...rest }) => {
    return (
        <Box className={clsx('container main-container-spacing', className)} {...rest}>
            {children}
        </Box>
    );
};
PageLayout.Header = PageHeader;
PageLayout.Tabs = TabsWithActions;
PageLayout.prototype = {
    className: PropTypes.string,
    children: PropTypes.node,
};
export default PageLayout;
